/* eslint-disable import/max-dependencies */
import {
  takeEvery, put, call, select,
} from "redux-saga/effects";
import { addNotification, setErrors, type Response } from "@fas/ui-framework";
import errorsTransform from "../../helpers/errorsTransform";
import { SAVE_REDIRECT_SAGA, SAVE_REDIRECT_LOADING } from "../../helpers/constants";
import setLoading from "../../actions/loading";
import RedirectApi from "../../services/redirectApi";
import type { SaveRedirectSagaAction } from "../../actions/redirect";
import type { RedirectLoadingTypes as LoadingTypes } from "../../actions/loading";
import { getHashValue } from "../../services/jusCan";
import { schema } from "./schema";
import type { State } from "../../pages/AppStoreWrapper";

export function* makeFetch(action: SaveRedirectSagaAction) {
  const state: State = yield select();

  const validationResult = schema.validate({
    redirectInfo: state.redirect.toJS(),
  });
  const validationErrors = errorsTransform(validationResult);

  yield put(setErrors(validationErrors));
  if (Object.keys(validationErrors).length) {
    return;
  }

  try {
    yield put(setLoading<LoadingTypes>(SAVE_REDIRECT_LOADING, true));
    const { redirectId, redirect, navigate }: SaveRedirectSagaAction = action;

    if (redirectId) {
      yield call(RedirectApi.updateRedirect, redirectId, redirect);
      yield put(addNotification({ message: "Successfully saved", severity: "success" }));
    }
    else {
      const response: {
        data: { result: { id: string } }
      } = yield call(RedirectApi.createRedirect, redirect);

      const {
        data: {
          result: { id: newRedirectId },
        },
      } = response;

      yield put(addNotification({ message: "Successfully created", severity: "success" }));
      navigate(`/redirects/edit/${newRedirectId}?hashId=${getHashValue()}`);
    }
  }
  catch (error: any) {
    yield put(addNotification({ message: error.errorMessage || "Failed to save", severity: "error" }));
    // eslint-disable-next-line no-console
    console.error(error);
  }
  finally {
    yield put(setLoading<LoadingTypes>(SAVE_REDIRECT_LOADING, false));
  }
}

export default function* watch() {
  yield takeEvery(SAVE_REDIRECT_SAGA, makeFetch);
}
